import { Helmet } from '@dr.pogodin/react-helmet'
import { useLocation } from 'react-router-dom'

// Canonical por omissão (28/10/2026). Só 8 páginas usavam <SEO> com url; as
// outras (/pedir, /termos, /categorias/…) não tinham canonical, e o Google
// indexou à parte www.tamoaki.co.ao/… e /pedir?origem=hero. Aponta sempre
// para tamoaki.co.ao + caminho, sem query; o <SEO> de cada página, mais
// abaixo na árvore, sobrepõe-se.
export function CanonicalPadrao() {
  const { pathname } = useLocation()
  const caminho = pathname !== '/' ? pathname.replace(/\/+$/, '') : '/'
  return (
    <Helmet>
      <link rel="canonical" href={`https://tamoaki.co.ao${caminho}`} />
    </Helmet>
  )
}
